import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  services = [
    {
      name: 'Transcription Services',
      key: 'Transcription'
    },
    {
      name: 'Translation Services',
      key: 'Translation'
    },
    {
      name: 'Media Production Services',
      key: 'Production'
    },
  ]

  selectedService;

  constructor() { }

  ngOnInit(): void {
    this.selectedService = this.services[0];
  }

  serviceMenuSelect(item) {
    this.selectedService = item;
  }

}
